import React, {Component, ReactElement, ReactNode} from 'react'
import {Location} from 'react-router-dom'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import NatTokenRepo from '../token/repository/NatTokenRepo';
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import {BreakPoint, Colors, FontSize, FontSizeInPixel} from '../../../styledComponents/Constants';
import {DisplayBlockDiv, DisplayItemDividerForPageTop,} from '../../../styledComponents/DisplayItem';
import {
    PlainLinkStyledBackButton,
    PlainLinkStyledButton,
    StyledSecondaryButton,
    UnstyledLinkStyledButton
} from '../../../styledComponents/Button';
import {Nullable} from '../../../app/TypeHelpers';
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage';
import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience';
import {DisplayItemDividerDialog, StyledPageTitle} from '../../../components/reservations/components/CommonStyle';
import {Box, CardActionArea, Dialog, DialogProps, useMediaQuery} from '@mui/material';
import {RESIDENT_USER_TYPE} from '../../../CodeMaster';
import {HKConstants} from '../../../HKConstants';
import AuthorityChecker from '../../../components/AuthorityChecker';
import {SessionStorageHelper} from '../../../SessionStorageHelper';
import {
    MainUser,
    NatGetResidentUserInvolvingSub,
    SubUser,
} from '../residentUser/repository/NatGetResidentUserInvolvingSub';
import {judgeAuthorityCheck, NatAsyncCallFunction} from '../../common/util/Natutil';
import {Close, HelpOutline, HowToReg, PersonAdd} from '@mui/icons-material'
import {TopRowFlexContainer} from '../../../styledComponents/FlexComponents';
import {generateMedia} from 'styled-media-query';
import NatResidentMessageDialogComponent from '../common/resident/NatResidentMessageDialogComponent';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import {Messages} from '../../../Messages';
import ResidentGeneralMeetingRepo, {
    GetUnitOwnerByLoginUserRoomResponse,
    UnitOwner
} from '../../../components/generalMeeting/ResidentGeneralMeetingRepo'

interface Props {
    condominiumCd: string,
    ridgeCd: string,
    roomNumber: string,
    residentUserRepo: NatResidentUserRepo,
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
    tokenRepo: NatTokenRepo,
    location: Location,
}

interface States {
    mainUser: MainUser
    subUser: SubUser[]
    unitOwner: Nullable<UnitOwner>
    loginUserId: Nullable<string>
    hintDialogOpen: boolean
    errorDialogOpen: boolean
    isLoadCompleted: boolean
}

const MAIN_USER_COUNT: number = 1;
const LOGIN_USER_RESIDENT_USER_TYPE: string = 'loginUserResidentUserType';

const HintDialog: React.FC<DialogProps> = props => {
    const matches = useMediaQuery(`(min-width: ${BreakPoint.Sp})`)
    return (
        <Dialog
            {...props}
            fullScreen={!matches}
        >
            {props.children}
        </Dialog>
    )
}

class NatResidentUserManagePage extends Component<Props & ResidentPagePropsSet, States> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props);
        this.state = {
            mainUser: {
                seq: 0,
                userId: '',
                familyName: '',
                firstName: '',
                mailAddressPc: '',
                mailAddressMb: ''
            },
            subUser: [],
            unitOwner: null,
            loginUserId: '',
            hintDialogOpen: false,
            errorDialogOpen: false,
            isLoadCompleted: false,
        };
        this.handleHintDialogClick = this.handleHintDialogClick.bind(this);
        this.handleHintDialogCloseClick = this.handleHintDialogCloseClick.bind(this);
        this.handleErrorDialogOkClick = this.handleErrorDialogOkClick.bind(this);
        this.backButtonClick = this.backButtonClick.bind(this);
        this.onClickUser = this.onClickUser.bind(this);
        this.onClickAddSubUser = this.onClickAddSubUser.bind(this);
        this.onClickConfirmUnitOwner = this.onClickConfirmUnitOwner.bind(this)
        this.getHintDialogComponent = this.getHintDialogComponent.bind(this);
        this.getErrorDialogComponent = this.getErrorDialogComponent.bind(this);
        this.getUserElement = this.getUserElement.bind(this);
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading();
        try {
            this.setState({
                loginUserId: SessionStorageHelper.getStringItemOrNull('userId')
            })
            // 居住者ユーザ取得(サブユーザ含む)
            const userInfo: Nullable<NatGetResidentUserInvolvingSub> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserInvolvingSub.bind(
                    this.props.residentUserRepo,
                    this.props.condominiumCd,
                    this.props.ridgeCd,
                    this.props.roomNumber
                ), this.props.navigate)
            if (userInfo?.details) {
                this.setState({
                    mainUser: userInfo.details.mainUser,
                    subUser: userInfo.details.subUser
                })
            }
            if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION)) {
                const unitOwnerResponse: Nullable<GetUnitOwnerByLoginUserRoomResponse> = await NatAsyncCallFunction(
                    this.props.residentGeneralMeetingRepo.getUnitOwnerByLoginUserRoom.bind(
                        this.props.residentGeneralMeetingRepo,
                    ),
                    this.props.navigate,
                )
                if (unitOwnerResponse) {
                    this.setState({
                        unitOwner: unitOwnerResponse.details
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading();
            this.setState({
                isLoadCompleted: true
            })
        }
    }

    handleHintDialogClick(): void {
        this.setState({hintDialogOpen: true})
    }

    handleHintDialogCloseClick(): void {
        this.setState({hintDialogOpen: false})
    }

    handleErrorDialogOkClick(): void {
        this.setState({errorDialogOpen: false})
    }

    backButtonClick(): void {
        this.props.navigate(
            `/resident/personalSetting`,
        )
    }

    onClickUser = (seq: number) => (): void => {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/ridges/${this.props.ridgeCd}` +
            `/rooms/${this.props.roomNumber}/users/${seq}`,)
    }

    onClickAddSubUser(): void {
        if (this.state.subUser.length >= HKConstants.VRS.RES.SUB_USER_ADD_LIMIT) {
            this.setState({errorDialogOpen: true})
            return;
        }
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/ridges/${this.props.ridgeCd}/rooms/` +
            `${this.props.roomNumber}/subUsers/add`,
        )
    }

    onClickConfirmUnitOwner(): void {
        this.props.navigate(
            '/resident/general-meeting/unit-owner-confirmation-verification-method-selection',
            {
                state: {
                    rootPageUrl: `/resident/condominiums/${this.props.condominiumCd}/ridges/${this.props.ridgeCd}/rooms/${this.props.roomNumber}/users`
                }
            }
        )
    }

    getHintDialogComponent(): ReactNode {
        const {hintDialogOpen} = this.state
        return (<>
                <HintDialog
                    id={'hint-dialog'}
                    open={hintDialogOpen}
                    fullWidth
                >
                    <HintDialogArea>
                        <HintDialogTitleArea>
                            <TopRowFlexContainer>
                                <HintDialogTitleStyled>ユーザが利用できる機能の違い</HintDialogTitleStyled>
                                <HintDialogCloseButton onClick={this.handleHintDialogCloseClick} id={'close'}>
                                    <Close style={{
                                        color: `${Colors.AccentDark}`,
                                        fontSize: `${FontSize.Big}`,
                                        paddingTop: '3px'
                                    }}/>
                                </HintDialogCloseButton>
                            </TopRowFlexContainer>
                        </HintDialogTitleArea>
                        <DisplayItemDividerDialog/>
                        <HintDialogContentsArea>
                            <HintDialogTextArea>
                                <DialogHeadlineStyled>メインユーザのみご利用いただける機能</DialogHeadlineStyled>
                                <DialogTextStyled>
                                    <div>・サブユーザの追加・削除</div>
                                    <div>・サブユーザの利用制限の設定</div>
                                    <div>・WEB口座振替申請</div>
                                </DialogTextStyled>
                                <BlockSpacer height={'24px'}/>
                                <DialogHeadlineStyled>サブユーザのご利用に権限の設定が必要な機能</DialogHeadlineStyled>
                                <DialogTextStyled>
                                    <div>・請求金額閲覧</div>
                                    <div>・領収書発行</div>
                                    <div>・口座情報閲覧</div>
                                    <BlockSpacer height={'24px'}/>
                                    <div>上記以外の機能については、メインユーザ・サブユーザともにご利用いただけます。</div>
                                </DialogTextStyled>
                                <BlockSpacer height={'24px'}/>
                                <DialogHeadlineStyled>区分所有者のみご利用いただける機能</DialogHeadlineStyled>
                                <DialogTextStyled>
                                    <div>・総会</div>
                                </DialogTextStyled>
                                <DialogTextStyled>
                                    <BlockSpacer height={'24px'}/>
                                    <div>※機能は物件のご契約内容により異なります。</div>
                                </DialogTextStyled>
                            </HintDialogTextArea>
                        </HintDialogContentsArea>
                        <BlockSpacer height={'24px'}/>
                    </HintDialogArea>
                </HintDialog>
            </>
        )
    }

    getErrorDialogComponent(): ReactElement | null {
        return (
            <NatResidentMessageDialogComponent
                open={this.state.errorDialogOpen}
                params={{
                    title: '確認',
                    titleIcon: <ErrorDialogTitleIconWrapper><ReportProblemOutlinedIcon titleAccess={'warning'}/>
                    </ErrorDialogTitleIconWrapper>,
                    errorLevel: Messages.EOPCC0034.errorLevel,
                    message: Messages.EOPCC0034.toString(HKConstants.VRS.RES.SUB_USER_ADD_LIMIT),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleErrorDialogOkClick,
                        },
                    ],
                }}
            />
        )
    }

    getUserElement(): ReactElement | null {
        return (
            <>
                <UserListActionArea onClick={this.onClickUser(this.state.mainUser.seq)}>
                    {this.NatUserListItemComponent(
                        this.state.mainUser.userId,
                        this.state.mainUser.familyName,
                        this.state.mainUser.firstName,
                        RESIDENT_USER_TYPE.MAIN
                    )}
                </UserListActionArea>
                {this.state.subUser?.length > 0 && this.state.subUser.map((subUser, index) =>
                    <UserListActionArea key={index} onClick={this.onClickUser(subUser.seq)}>
                        {this.NatUserListItemComponent(
                            subUser.userId,
                            subUser.familyName,
                            subUser.firstName,
                            RESIDENT_USER_TYPE.SUB)}
                    </UserListActionArea>
                )}
            </>
        )
    }

    NatUserListItemComponent(
        userId: string,
        familyName: string,
        firstName: string,
        userType: RESIDENT_USER_TYPE
    ): ReactElement | null {
        return (
            <>
                <UserListArea>
                    <UserListName>
                        <UserListNameStyled>{familyName + ' ' + firstName}</UserListNameStyled>
                        {userId === this.state.loginUserId && <LoginUserStyle>（あなた）</LoginUserStyle>}
                    </UserListName>
                    <ForwardArrow/>
                    <UserRole>
                        {userType.value === RESIDENT_USER_TYPE.MAIN.value &&
                            <PrimaryTag>メインユーザ</PrimaryTag> ||
                            userType.value === RESIDENT_USER_TYPE.SUB.value &&
                            <SecondaryTag>サブユーザ</SecondaryTag>}
                        {userId === this.state.unitOwner?.userId &&
                            <SecondaryTag>区分所有者</SecondaryTag>
                        }
                    </UserRole>
                </UserListArea>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.backButtonClick}>
                    戻る
                </PlainLinkStyledBackButton>
                <BlockSpacer height={'14px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <StyledPageTitle>
                    ユーザ管理
                </StyledPageTitle>
                <BlockSpacer height={'20px'}/>
                <div>ユーザの種類は「メインユーザ」と「サブユーザ」があり、それぞれご利用いただける機能が異なります。</div>
                <div>メインユーザはサブユーザの追加・削除と、サブユーザに対して素敵ネットの一部機能について利用制限の設定ができます。</div>
                <BlockSpacer height={'20px'}/>
                <HintDialogStyledButton onClick={this.handleHintDialogClick}>
                    <HelpOutline style={{fontSize: `${FontSize.Big}`, paddingRight: '5px'}}/>ユーザが利用できる機能の違い
                </HintDialogStyledButton>
                <ItemHeading>ユーザ({this.state.subUser.length + MAIN_USER_COUNT}
                    /{HKConstants.VRS.RES.SUB_USER_ADD_LIMIT + MAIN_USER_COUNT}人)</ItemHeading>
                <GridContainer>
                    {this.getUserElement()}
                    {SessionStorageHelper.getStringItemOrNull(LOGIN_USER_RESIDENT_USER_TYPE) ===
                        RESIDENT_USER_TYPE.MAIN.value &&
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_RESIDENT_USER}>
                            <PlainSubUserAddLinkStyledButton onClick={this.onClickAddSubUser}>
                                <PersonAdd style={
                                    {fontSize: `${FontSize.Big}`, paddingRight: '20px'}
                                }/>サブユーザを追加
                            </PlainSubUserAddLinkStyledButton>
                        </AuthorityChecker>
                    }
                </GridContainer>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION}>
                    <ItemHeading>区分所有者</ItemHeading>
                    <GridContainer>
                        <MessageArea>
                            <div>区分所有者の方は確認を行ってください。</div>
                            <div>確認を行うと総会機能をご利用になれます。</div>
                        </MessageArea>
                        <PlainSubUserAddLinkStyledButton onClick={this.onClickConfirmUnitOwner}>
                            <HowToReg style={
                                {fontSize: `${FontSize.Big}`, paddingRight: '20px'}
                            }/>区分所有者の確認
                        </PlainSubUserAddLinkStyledButton>
                    </GridContainer>
                </AuthorityChecker>
                <Box height={'20px'}/>
                <DisplayBlockDiv>
                    <StyledSecondaryButton onClick={this.backButtonClick}>戻る</StyledSecondaryButton>
                </DisplayBlockDiv>
                {this.getHintDialogComponent()}
                {this.getErrorDialogComponent()}
            </>
        )
    }
}

export default createResidentPage(NatResidentUserManagePage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
});

const ForwardArrow = styled.div`
  content: '';
  width: 0.9rem;
  height: 0.9rem;
  border-top: solid 2px ${Colors.Body};
  border-right: solid 2px ${Colors.Body};
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  display: grid;
  grid-column: 2;
  grid-row: 1/3;
  place-self: center;

`

const UserListActionArea = styled(CardActionArea)`
  &.MuiCardActionArea-root {
  }
`
const UserListArea: StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 92% 8%;
  border-bottom: 1px solid ${Colors.AccentLight};
  ${breakPoint.lessThan('sp')`
      padding: 10px 15px;
  `}
`
const UserListName: StyledDiv = styled.div`
  grid-column: 1;
  grid-row: 1/2;
  padding: 10px 15px 5px;
  height: 24px;
  font-size: ${FontSizeInPixel.Body};
  ${breakPoint.lessThan('sp')`
      padding: 0px 0px 5px;
  `}
`
const UserListNameStyled: StyledDiv = styled.div`
  display: inline;
  font-weight: bold;
`
const LoginUserStyle = styled.div`
  display: inline;
  font-weight: 400;
`
const UserRole: StyledDiv = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.AccentDark};
  line-height: 1.5;
  display: flex;
  gap: 10px;
  grid-column: 1;
  grid-row: 2/3;
  padding: 5px 15px 10px;
  ${breakPoint.lessThan('sp')`
     padding: 5px 0px 0px;
  `}
`
const PrimaryTag: StyledDiv = styled.div`
  background: rgba(242, 248, 251, 0.7);
  width: fit-content;
    border-radius: 4px;
  padding: 2px 10px;
`
const SecondaryTag: StyledDiv = styled.div`
  background: rgba(242, 242, 242, 1);
  width: fit-content;
  padding: 2px 10px;
  border-radius: 4px;
  padding: 2px 10px;
`
const MessageArea = styled.div`
  padding: 15px 15px 0;
`
const HintDialogStyledButton = styled(PlainLinkStyledButton)`
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  position: relative;
  text-align: right;
  color: ${Colors.Primary}
`
const HintDialogArea = styled.div`
  padding: 17px 15px 15px;
`
const HintDialogTitleArea = styled.div`
  height: 47px;
`
const HintDialogTitleStyled = styled.div`
  font-size: ${FontSize.Accent};
  color: ${Colors.AccentDark};
  font-weight: 700;
`
const HintDialogCloseButton = styled(UnstyledLinkStyledButton)`
  height: 24px;
  width: 24px;
  color: ${Colors.AccentDark};
`
const HintDialogContentsArea = styled.div`
  margin-top: 15px
`
const HintDialogTextArea = styled.div`
  padding-right: 70px;
  ${breakPoint.lessThan('sp')`
       padding-right: 0px;
  `}
`
const DialogHeadlineStyled = styled.div`
  color: ${Colors.Body};
  font-weight: 700;
`
const DialogTextStyled = styled.div`
  color: ${Colors.Body};
`
const PlainSubUserAddLinkStyledButton = styled(PlainLinkStyledButton)`
  display: flex;
  align-items: center;
  padding: 21.5px 15px 21.5px;
  position: relative;
  text-align: right;
  color: ${Colors.Primary}
`
const GridContainer: StyledDiv = styled.div`
  background-color: rgba(255, 255, 255, 255.0);
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
`
const ItemHeading = styled.div`
  background-color: ${Colors.AccentLight};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  font-size: ${FontSize.Body};
  padding: 6px 15px 6px;
  box-sizing: border-box;
  overflow: hidden;
`
const ErrorDialogTitleIconWrapper = styled.div`
  line-height: 1;

  svg {
    font-size: ${FontSize.Big} !important;
    ${currentMedia.lessThan('sp')`
      font-size: ${FontSize.Accent}!important;
   `};
  }
`;

